import { render, staticRenderFns } from "./host-settings.vue?vue&type=template&id=494ea513&scoped=true&"
import script from "./host-settings.vue?vue&type=script&lang=js&"
export * from "./host-settings.vue?vue&type=script&lang=js&"
import style0 from "./host-settings.vue?vue&type=style&index=0&id=494ea513&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ea513",
  null
  
)

export default component.exports